import { useMemo } from 'react';

const RUTUBE_VIDEO_QUERY_PARAMS = {
  skinColor: '0468ff',
  autoplay: 'true',
};

export const useRutubeVideoLink = (baseUrl: string) => {
  return useMemo(() => {
    const url = new URL(baseUrl);

    Object.entries(RUTUBE_VIDEO_QUERY_PARAMS).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    return url.toString();
  }, [baseUrl]);
};
